import { render } from "./MetadataInput.vue?vue&type=template&id=648142be&scoped=true&ts=true"
import script from "./MetadataInput.vue?vue&type=script&lang=ts"
export * from "./MetadataInput.vue?vue&type=script&lang=ts"

import "./MetadataInput.vue?vue&type=style&index=0&id=648142be&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-648142be"]])

export default __exports__